import PropTypes from 'prop-types';
import Errors from 'components/Errors';
import { EXPIRED_TOKEN_ERROR } from 'config/constants';

const loginFailedMessage = {
  title: 'Login Failed',
  subTitle: 'An error occurred, please try again later. If the matter is urgent please contact us.',
};

const bookingNotFoundMessage = {
  title: 'Booking not found',
  subTitle: 'We’ve been unable to find a booking matching those details, please check your details and try again.',
};

const tokenExpiredMessage = {
  title: 'Session expired',
  subTitle: 'You have been logged out due to inactivity. Please enter your details again to log in.',
};

const getCorrespondingMessage = ({ error }) => {
  if (error.message === EXPIRED_TOKEN_ERROR) {
    return tokenExpiredMessage;
  }

  if (error.httpStatus === 401) {
    return bookingNotFoundMessage;
  }

  return loginFailedMessage;
};

const LoginError = ({ error }) => {
  const message = getCorrespondingMessage({ error });
  return <Errors title={message.title} subTitle={message.subTitle} />;
};

LoginError.propTypes = {
  error: PropTypes.object.isRequired,
};

export default LoginError;
